import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "__barrel_optimize__?names=Carousel!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/components/AddCartButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookSlick"] */ "/app/app/[lng]/components/BookSlick.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/components/CurrencyPrice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/components/ErrorMessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/components/WishButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/icons/hot-1-circle.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/hot-1-shadow.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/multiDiscountCover-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/multiDiscountCover.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/NO.1-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/NO.1.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/NO.2-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/NO.2.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/NO.3-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/NO.3.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/rect-gold-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/rect-gold-sub.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/rect-gold.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/rect-red.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/rightArrow.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/singleDiscountCover-mobile.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/singleDiscountCover.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/subSingleDiscountCover.svg");
